import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';

import { ViewBasePage } from '@shared/pages';
import { CustomersService } from '@shared/services';
import type { TCustomer } from '@shared/models';

@Component({
    'selector': 'app-customers',
    'templateUrl': './customers.page.html',
    'styleUrls': ['./customers.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ]
})
export class CustomersPage extends ViewBasePage implements OnInit {
    public customers: TCustomer[] = [];

    constructor(private customersService: CustomersService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_CUSTOMERS);
    }

    public override async ngOnInit(): Promise<void> {
        // this.vm = super.getViewModel();
        this.customers = await this.customersService.getAll();
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-customers-tour');
    }

    public onCustomerSelectedClick(/* customer */) {
        return;
    }

    public getLastShuttleDate(customer: TCustomer): string {
        const lastShuttleDate = customer.shuttleDates[customer.shuttleDates.length - 1];
        const str = this.dateService.formatTimestamp(lastShuttleDate);
        return str;
    }

    public getMaskedPhoneNumber(customer: TCustomer): string {
        if (!customer)
            return '';

        const cellPhone = customer.cellPhone;
        const maskedCell = this.utilsService.maskPhoneNumber(cellPhone);

        return maskedCell;
    }
}
